import request from "./axios";
import qs from "qs";
// 获取会议

export const queryConferenceConfig = params => {
  return request({
    method: "get",
    url: `/app/meeting/home/${params}`,
    auth: true
  });
};

export const queryRegistered = params => {
  return request({
    method: "get",
    url: `/app/meeting/registerPage/${params}`,
    auth: true
  });
};

// 是否报名需要验证码
export const fetchNeedcaptcha = params => {
  return request({
    method: "get",
    url: `/app/live/needcaptcha?projectCode=${params}`,
    auth: true
  });
};
export const signUpLive = data => {
  return request({
    method: "post",
    url: "app/live/saveSign",
    auth: true,
    data: qs.stringify(data)
  });
};
